export default __webpack_public_path__ + "static/media/a037-student-t3-7.ed77bd92.svg";